import { getState } from '../../reduxService';
import user from './user/userSlice';
import macra1Reducers from '../MACRA_1/store/reducers';
import macra2Reducers from '../MACRA_2/store/reducers';
import material from './material/materialSlice';
import materialDetail from './material/materialDetailSlice';
import projectInfo from './projectInfo/projectInfoSlice';

export default {
    user,
    projectInfo,
    macra1: macra1Reducers,
    macra2: macra2Reducers,
    material,
    materialDetail,
};

export const getUser = () => getState().user;
export const macra1 = () => getState().macra1;
export const macra2 = () => getState().macra2;
export const getProjectInfo = () => getState().projectInfo;
